(() => {
  const formSelector = '[data-cart-drawer-addon-form]';
  const tabSelector = '[data-cart-drawer-addon-tab]';

  document.addEventListener('click', (event) => {
    const tab = event.target.closest(tabSelector);
    if (!tab || tab.disabled) return;

    const section = tab.closest('.cart-drawer-addons');
    if (!section) return;

    const selectedPanel = tab.dataset.cartDrawerAddonTab;
    section.querySelectorAll(tabSelector).forEach((button) => {
      const isSelected = button === tab;
      button.classList.toggle('is-active', isSelected);
      button.setAttribute('aria-selected', String(isSelected));
    });
    section.querySelectorAll('[data-cart-drawer-addon-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.cartDrawerAddonPanel !== selectedPanel;
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(formSelector);
    if (!form) return;

    event.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const button = form.querySelector('button[type="submit"]');
    if (!drawer || !button || button.disabled) return;

    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);
      formData.append(
        'sections',
        drawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const response = await fetch(routes.cart_add_url, config);
      const cartData = await response.json();
      if (!response.ok || cartData.status) throw new Error(cartData.description || 'Unable to add this product.');

      drawer.setActiveElement(button);
      drawer.renderContents(cartData);
    } catch (error) {
      console.error(error);
      button.textContent = 'Try again';
      button.disabled = false;
      window.setTimeout(() => {
        button.textContent = originalLabel;
      }, 1800);
    }
  });
})();